<template>
  <Modal class="addr-form-wrap" v-model="addrModal" v-bind="modelBase">
    <table class="addr-tab" cellpadding="0" cellspacing="0">
      <tr>
        <td>
          <Input type="text" placeholder="收货人姓名：" v-model="receiveName"/>
        </td>
      </tr>
      <tr>
        <td>
          <Input type="text" placeholder="手机号码：" v-model="receivePhone"/>
        </td>
      </tr>
      <tr>
        <td>
          <DatePicker type="date" placeholder="收货时间：收货时间不限"
          class="addr-date-picker" v-model="receiveTime"></DatePicker>
        </td>
      </tr>
      <tr>
        <td>
          <al-cascader level="2" placeholder="所在地区：" v-model="address"/>
        </td>
      </tr>
    </table>
    <Input type="textarea" v-model="addressDetail" placeholder="详细地址：" class="addr-detail"/>
    <div slot="footer">
      <Button type="error" size="large" long :loading="modal_loading" class="addr-submit-btn"
      @click="submitConfirm">确认地址</Button>
    </div>
  </Modal>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      addrTips: true,
      addrModal: false,
      modelBase: {
        title: '新增地址',
      },
      modal_loading: false,
      receiveName: '',
      receivePhone: '',
      receiveTime: '',
      address: [],
      addressDetail: '',
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo,
      isLogin: state => state.login.isLogin,
    }),
  },
  methods: {
    async submitConfirm() {
      const vm = this;
      if (localStorage.hadSubmitInfo) {
        this.$Modal.confirm({
          title: '您已提交过收货信息，确定是否再次提交？',
          onOk() {
            vm.submitAddr();
          },
        });
      } else {
        this.submitAddr();
      }
    },
    async submitAddr() {
      const phoneReg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      if (!phoneReg.test(this.receivePhone)) {
        this.$Message.warning('请输入正确格式的手机号！');
        return;
      }
      let sAddr = '';
      this.address.forEach((item) => {
        sAddr += item.name;
      });
      sAddr += this.addressDetail;
      this.modal_loading = true;
      const res = await axios.post('/api/winAddress', {
        receiveName: this.receiver,
        phone: this.receivePhone,
        receive_time: this.receiveTime,
        address: sAddr,
        user_id: this.userInfo.union_user_id || this.userInfo.openid,
        f_id: 1,
      });
      if (res.data.ret === 1) {
        this.$Message.success('提交成功！');
        this.addrModal = false;
        localStorage.hadSubmitInfo = 1;
      }
      this.modal_loading = false;
    },
    setAddrModel() {
      if (!(this.isLogin || this.addrModal)) {
        this.$store.commit('setShowLogin', true);
        return;
      }
      this.addrModal = !this.addrModal;
    },
  },
};
</script>

<style>
.addr-tab{
  width: 100%;
  border-collapse: collapse;
}
.addr-tab td{
  border: 1px solid #dcdee2;
}
.addr-tab .ivu-input{
  border: 0;
}
.addr-date-picker{
  width: 100%;
}
.addr-detail{
  margin-top: 5%;
}
.addr-detail .ivu-input{
  border-radius: 0;
}
.addr-submit-btn{
  background-color: #dfcf1e;
  border-color: #dfcf1e;
}
.addr-submit-btn:hover{
  background-color: #ccbc0b;
  border-color: #ccbc0b;
}
</style>



// WEBPACK FOOTER //
// src/components/addrForm.vue